export default {
    BLOQUEAR: 0,
    DISPENSAR: 1,
    SUSTITUIR: 2,
    ANULAR: 3,
    ELABORAR_FM: 4,
    ANULAR_FM: 5
}
